import { useEffect, useRef } from 'react';

interface UseIdleTimerProps {
    timeout: number;
    onIdle: () => void;
    enabled?: boolean;
}

export const useIdleTimer = ({ timeout, onIdle, enabled = true }: UseIdleTimerProps) => {
    const timeoutRef = useRef<NodeJS.Timeout>();

    const resetTimer = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(onIdle, timeout);
    };

    const handleActivity = () => {
        if (enabled) {
            resetTimer();
        }
    };

    useEffect(() => {
        if (!enabled) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            return;
        }

        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart', 'click'];

        events.forEach(event => {
            document.addEventListener(event, handleActivity, true);
        });

        resetTimer(); // Start the timer

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            events.forEach(event => {
                document.removeEventListener(event, handleActivity, true);
            });
        };
    }, [enabled, timeout]);

    return { resetTimer };
};